import React from 'react';
import { Box, Button, Typography } from '@mui/material';
import { Link } from 'gatsby-theme-material-ui';
import { useCookies } from 'react-cookie';
import { BoltIcon } from '../../kit/icons/BoltIcon';
import { styles } from './styles';

const isBrowser = typeof window !== 'undefined';

export function CookiesNotification() {
  const [cookies, setCookie] = useCookies(['cookies_accepted']);

  const handleCookieAccept = () => {
    setCookie('cookies_accepted', 'true', { maxAge: 365 * 24 * 60 * 60 });
  };

  return (
    <Box>
      {isBrowser && !cookies.cookies_accepted && (
        <Box sx={styles.notificationRoot}>
          <Box sx={styles.textContainer}>
            <BoltIcon sx={styles.icon} />
            <Typography sx={styles.textDesktop}>
              Продолжая пользоваться сайтом, вы соглашаетесь с использованием
              файлов cookie. Подробнее в{' '}
              <Link variant="kitSecondary" href="/docs/cookies_agreement.pdf">
                согласии
              </Link>{' '}
              и{' '}
              <Link
                variant="kitSecondary"
                href="/docs/confidentiality_agreement.pdf"
              >
                политике
              </Link>
              .
            </Typography>
            <Typography variant="mobileP3" sx={styles.textMobile}>
              Мы используем cookies. Подробнее в{' '}
              <Link
                variant="kitSecondary"
                href="/docs/cookies_agreement.pdf"
                sx={{ fontSize: '12px' }}
              >
                согласии
              </Link>{' '}
              и{' '}
              <Link
                variant="kitSecondary"
                href="/docs/confidentiality_agreement.pdf"
                sx={{ fontSize: '12px' }}
              >
                политике
              </Link>
              .
            </Typography>
          </Box>
          <Box sx={{ marginLeft: 4 }}>
            <Button
              variant="outlined"
              onClick={handleCookieAccept}
              sx={styles.buttonDesktop}
            >
              Хорошо
            </Button>
            <Button
              variant="outlined"
              size="small"
              onClick={handleCookieAccept}
              sx={styles.buttonMobile}
            >
              ОК
            </Button>
          </Box>
        </Box>
      )}
    </Box>
  );
}
